export default {
  MuiCheckbox: {
    root: {
      fontSize: 12,
      padding: 0,
    },
  },
};
